module.exports = (__webpack_require__(0))(62);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/MetadataMixin.js from dll-reference girder_lib
// module id = 80
// module chunks = 0